// ═══════════════════════════════════════════════════════════════════════════
// permisoModulo — la ÚNICA regla de «este usuario ve lo gateado por el código X»
// ═══════════════════════════════════════════════════════════════════════════
// La usan el sidebar (`Layout.jsx`, ítem por ítem por su `permisoModulo`) y el
// router (`App.jsx`, ruta por ruta por su `permiso`). Si cada uno la escribiera
// por su lado, el menú mostraría un ítem cuya ruta el router no monta (o al
// revés) el día que una de las dos copias cambie.
//
// `userDoc` es el EFECTIVO de `useAuth()` (con la simulación de rol aplicada)
// y `permModulosSet` el de `useModulosVisibles()`: los códigos donde el rol
// tiene `ver`. El Wizard ve todo.
// ═══════════════════════════════════════════════════════════════════════════

/** @returns {boolean} */
export function veCodigoDeModulo (userDoc, permModulosSet, codigo) {
  return userDoc?.esWizard === true || (permModulosSet?.has(codigo) ?? false)
}
